export default __webpack_public_path__ + "static/song-a90489098fe583d7b46206a350c93d4d.mp3";